import { styled } from '@mui/material/styles';
import { Grid, Paper } from '@mui/material';

export const StyledContainer = styled(Grid)({
  position: 'relative',
  height: '100%',
  overflowX: 'hidden',
});

export const StyledGridItem = styled(Grid)({});

export const StyledPaper = styled(Paper)({
  height: '100%',
  borderRadius: 0,
});

export const ChatWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ open }) => ({
  transition: 'padding-right 320ms cubic-bezier(0.22, 1, 0.36, 1)',
  paddingRight: 0,
  minWidth: 0,
  ...(open && {
    paddingRight: 'var(--panelWidth)',
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

export const RightPanel = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ open }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  height: '100%',
  width: 'var(--panelWidth)',
  transform: 'translateX(100%)',
  transition: 'transform 320ms cubic-bezier(0.22, 1, 0.36, 1)',
  overflow: 'hidden',
  background: 'transparent',
  pointerEvents: 'none',
  boxShadow:
    '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
  ...(open && {
    transform: 'translateX(0)',
    pointerEvents: 'auto',
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));

export const PanelInner = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ open }) => ({
  height: '100%',
  opacity: 0,
  transform: 'translateX(16px)',
  transition:
    'opacity 240ms ease, transform 320ms cubic-bezier(0.22, 1, 0.36, 1)',
  ...(open && {
    opacity: 1,
    transform: 'translateX(0)',
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
}));
